export enum HeaderFilterTypes {
  None = 'None',
  Incidents = 'Incidents',
  Jobs = 'Jobs',
  Incoming_Reports = 'Incoming_Reports',
}
